"use strict";
import { Ajax, setAlert } from "./helpers";
import Pristine from 'pristinejs';
document.addEventListener("DOMContentLoaded", function (event) {
    // ------------------------------------------------------ //
    // Pristine - form validation
    // ------------------------------------------------------ //
    const formD = document.getElementById("fn_demand-form"), pristineD = new Pristine(formD, {
        classTo: 'c_search__box', // rodič inputu
        errorTextParent: 'c_search__box', // rodič, kam se vloží hláška
        errorTextTag: 'div',
        errorTextClass: 'pristine-error' // Bootstrap třída pro text chyby
    }), loaderD = formD.querySelector('.p_loader'), alertD = document.getElementById('fn_alert'), termInput = document.getElementById("term");
    // Přidáno: zajistit správné zobrazení chybové hlášky pro flatpickr input
    // Pokud Pristine nevloží hlášku správně, ručně ji zobrazíme
    formD.addEventListener('submit', function (e) {
        var _a;
        e.preventDefault();
        const termBox = termInput.closest('.c_search__box');
        // Odstraň všechny existující pristine-error pro termBox
        if (termBox) {
            termBox.classList.remove('has-danger');
            termBox.querySelectorAll('.pristine-error').forEach(el => el.remove());
        }
        let valid = pristineD.validate();
        // Pokud termInput je prázdný, nastav valid na false a zobraz chybovou hlášku okamžitě
        if (termInput.value.trim() === '') {
            valid = false;
            if (termBox) {
                termBox.classList.add('has-danger');
                // Přidej chybovou hlášku vždy, pouze jednou
                const errorDiv = document.createElement('div');
                errorDiv.className = 'pristine-error';
                errorDiv.innerText = "Termín je důležitým parametrem a musí být vyplněn.";
                // Zajisti, že bude viditelná
                errorDiv.style.display = 'block';
                termBox.appendChild(errorDiv);
            }
            (_a = document.getElementById('fn_validate')) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
            return;
        }
        if (!valid) {
            // Ostatní chyby nech na Pristine
            return;
        }
        loaderD.classList.add('p_loader--active');
        const ajaxDemand = new Ajax('POST');
        ajaxDemand.request('', // Use form action URL as a string
        (responseData) => {
            loaderD.classList.remove('p_loader--active');
            if (responseData.result === 1) {
                setAlert(alertD, responseData.message, 'alert-success');
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'form_submission',
                        event_category: 'Poptávka',
                        event_action: 'Odesláno',
                        event_label: 'Formulář poptávky'
                    });
                }
            }
            else {
                setAlert(alertD, responseData.message, 'alert-danger');
            }
        }, (error) => {
            loaderD.classList.remove('p_loader--active');
            console.error('Chyba při odesílání:', error);
        }, formD);
    });
    // Přidáno: při změně hodnoty flatpickr inputu (např. výběr data) odstranit chybu
    termInput.addEventListener('change', function () {
        const termBox = termInput.closest('.c_search__box');
        if (termBox) {
            termBox.classList.remove('has-danger');
            termBox.querySelectorAll('.pristine-error').forEach(el => el.remove());
        }
    });
});
